import { useQuery } from '@tanstack/react-query';

import { fetchChat } from '../../api/chats';

import type { ChatResponse, UseChatOptions } from './types';

export const CHAT_QUERY_KEY = 'chat';

/**
 * Hook to fetch a single chat by ID.
 * Uses react-query for caching, background refetching, and deduplication.
 */
export function useChat(chatId: string | null, options: UseChatOptions = {}) {
  const { enabled = true } = options;

  return useQuery<ChatResponse, Error>({
    queryKey: [CHAT_QUERY_KEY, chatId],
    queryFn: () => fetchChat(chatId!),
    enabled: enabled && !!chatId,
    staleTime: 60 * 1000, // 1 minute
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
}
